import { render, staticRenderFns } from "./closedIndent.vue?vue&type=template&id=08dfa530&scoped=true&"
import script from "./closedIndent.vue?vue&type=script&lang=js&"
export * from "./closedIndent.vue?vue&type=script&lang=js&"
import style0 from "./closedIndent.vue?vue&type=style&index=0&id=08dfa530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dfa530",
  null
  
)

export default component.exports